<template>
  <div
    class="inner"
    :class="{ swiping: isSwiping }"
    :style="{ transform: `translateY(${translateY}px)` }"
  >
    <SwipeWrapper
      @pan-start="handleSwipeDownStart"
      @pan-move="handleSwipeMove"
      @pan-end="handleSwipeDownEnd"
    >
      <div class="swipe"></div>
    </SwipeWrapper>
    <h2>Отзыв отправлен!</h2>
    <p>
      Спасибо, что делитесь своим мнением! Отзыв отправлен на проверку и в
      скором времени будет опубликован на сайте.
    </p>
    <div class="buttons">
      <VButton
        class="button"
        @click="onClickHandler"
        @keydown.enter="onClickHandler"
      >
        Хорошо
      </VButton>
    </div>
    <IconPopupCross
      v-if="screenWidth !== 'mobile'"
      class="modal-cross"
      @click="closeModal"
    />
  </div>
</template>

<script>
import VButton from "@/components/ui/VButton.vue";
import IconPopupCross from "@/components/icons/IconPopupCross.vue";
import SwipeWrapper from "@/components/ui/SwipeWrapper.vue";

export default {
  name: "ReviewSuccessModal",
  components: { SwipeWrapper, IconPopupCross, VButton },

  data() {
    return {
      translateY: 0,
      isSwiping: false,
      threshold: 100,
    };
  },

  methods: {
    closeModal() {
      this.$store.dispatch("closeModal");
    },
    onClickHandler() {
      if (this.$route.name === "restaurant") {
        this.$store.dispatch("closeModal");
      } else {
        this.$store.commit({
          type: "resetClientRestaurants",
          value: "",
        });
        this.$store.commit({
          type: "setMapEditMode",
          value: "",
        });
        this.$store.dispatch("closeModal");
      }
    },
    handleSwipeDownStart() {
      this.isSwiping = true;
    },
    handleSwipeDownEnd() {
      if (this.translateY > this.threshold) {
        this.closeModal();
      } else {
        this.translateY = 0;
        this.isSwiping = false;
      }
    },
    handleSwipeMove(event) {
      if (event.deltaY > 0) {
        this.translateY = event.deltaY;
      }
    },
  },

  computed: {
    screenWidth() {
      return this.$store.getters.screenType;
    },
  },
};
</script>

<style lang="scss" scoped>
.inner {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 448px;
  margin: auto;
  padding: 32px 56px 40px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;

  @media screen and (max-width: 841px) {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    max-width: 100%;
    box-shadow: 0 -2px 10px 0 #0000000d;
    border-radius: 20px 20px 0 0;
    padding: 32px 24px 24px 24px;
  }

  &.swiping {
    transition: none;
  }
}

h2 {
  margin-bottom: 24px;
  text-align: center;
  font-weight: 600;
  font-size: 24px;
  line-height: 32px;
  color: #f0811e;
}

p {
  width: 100%;
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  text-align: center;
  color: #222222;
}

.buttons {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: 32px;

  @include mobile {
    width: 100%;
  }
}

.button {
  width: 336px;

  @include mobile {
    width: 100%;
  }
}

.modal-cross {
  position: absolute;
  top: 25px;
  right: 25px;
  cursor: pointer;
}

.swipe {
  display: none;

  @include mobile {
    display: block;
    position: absolute;
    width: 100%;
    height: 20px;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    border-radius: 16px 16px 0 0;
    background-color: #ffffff;

    &::before {
      content: "";
      left: 50%;
      position: absolute;
      top: 6px;
      transform: translate(-50%);
      width: 36px;
      height: 6px;
      border-radius: 4px;
      background-color: #d6d6d6;
    }
  }
}
</style>
